import React, { useEffect } from 'react';
import '../../App.css';
import '../NotFoundPage.css';


function NotFoundPage() {


    useEffect(() => {
        document.title = "404: Page not found | FresoTech";  
    }, []);

    return (
        <>
            <div className="PageError">
                <h1>404</h1>
                <div>
                    <p>Sorry! 
                        The page you're looking for <br/> cannot be found!</p>
                    <a href="/" className='b-to-homepage-btn' rel="noreferrer">
                        Visit Home
                    </a>
                </div>
            </div>
        </>
    );
}

export default NotFoundPage;